import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LoadingStatus } from 'src/app/core/domain/events/state_provider';
import { Dietitian } from 'src/app/data/dietitian/domain/dietitian';
import { DietitianStateProvider } from 'src/app/data/dietitian/domain/dietitian_state_provider';

export interface AccountViewModel {
  isLoading: boolean;
  error: string;
  dietitian: Dietitian;
}

@Injectable()
export class AccountFacade {
  constructor(private dietitianStateProvider: DietitianStateProvider) {
    // do nothing
  }

  get accountStatus$(): Observable<AccountViewModel> {
    return this.dietitianStateProvider.state$.pipe(
      map((e) => {
        return <AccountViewModel>{
          isLoading: e.loading == LoadingStatus.LOADING,
          error: e.loading == LoadingStatus.ERROR ? e.message : undefined,
          dietitian: e.entity,
        };
      }),
    );
  }
}
